import { render, staticRenderFns } from "./OfficeAdd.vue?vue&type=template&id=6977662d&scoped=true&"
import script from "./OfficeAdd.vue?vue&type=script&lang=js&"
export * from "./OfficeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6977662d",
  null
  
)

export default component.exports